export default "__VITE_ASSET__eba5bd8e__"